import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  CorpLodging,
  CorpPriceQuote,
  CorpReservation,
  CorpRoomInfoProducts,
  CorpRoomProduct,
} from "redmond";
import {
  setTripPurpose,
  setTripDescription,
  setUserSelectedTravelersList,
  updateUserPassenger,
  updateUserPassengersMultiple,
} from "../../../actions/actions";

import { IStoreState } from "../../../../../reducers/types";
import { CorpDesktopHotelBookWorkflow } from "./component";
import {
  getUserSelectedTravelerId,
  getUserPassengers,
  getOpaquePayments,
  getPriceQuoteRequest,
  getHotelBookChosenProduct,
  getHotelBookChosenRoomInfo,
  getConfirmationDetails,
  getPriceQuote,
  getHotelBookSelectedAvailability,
  getUserSelectedTravelersList,
  getRoomsCountInBook,
} from "../../../reducer";
import {
  getHotelShopCancellationSummary,
  getLoyaltyNumberForChosenProduct,
} from "../../../../shop/reducer/selectors";

import {
  mapStateToProps as baseMapStateToProps,
  mapDispatchToProps as baseMapDispatchToProps,
} from "../../capone/DesktopHotelBookWorkflow/container";
import { hasCfarAttached } from "../../../../ancillary/reducer";
import {
  getRewardsAccountForBanner,
  getEarnForHighestEarnRewardsAccount,
} from "../../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => {
  const travelers = getUserPassengers(state);
  const selectedTravelerId = getUserSelectedTravelerId(state);
  const selectedTraveler = travelers.find(
    (traveler) => traveler.id === selectedTravelerId
  );

  return {
    ...baseMapStateToProps(state),
    chosenProduct: getHotelBookChosenProduct(state) as CorpRoomProduct,
    roomInfoProduct: getHotelBookChosenRoomInfo(state) as CorpRoomInfoProducts,
    reservation: getConfirmationDetails(state) as CorpReservation,
    priceQuote: getPriceQuote(state) as CorpPriceQuote,
    selectedLodging: getHotelBookSelectedAvailability(state) as CorpLodging,
    selectedTravelerId,
    selectedTraveler,
    userPassengers: travelers,
    opaquePayments: getOpaquePayments(state),
    priceQuoteRequest: getPriceQuoteRequest(state),
    selectedTravelerLoyaltyNumber: getLoyaltyNumberForChosenProduct(state),
    selectedTravelersList: getUserSelectedTravelersList(state),
    cancellationSummary: getHotelShopCancellationSummary(state),
    hasCfarAttached: hasCfarAttached(state),
    largestValueAccount: getRewardsAccountForBanner(state),
    calculatedEarn: getEarnForHighestEarnRewardsAccount(state),
    roomsCount: getRoomsCountInBook(state),
  };
};

const mapDispatchToProps = {
  ...baseMapDispatchToProps,
  updateUserPassenger,
  updateUserPassengersMultiple,
  setUserSelectedTravelersList,
  setTripPurpose,
  setTripDescription,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CorpDesktopHotelBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const CorpConnectedDesktopHotelBookWorkflow = withRouter(
  connector(CorpDesktopHotelBookWorkflow)
);
